// HR Analytix main application sidebar navigation.
// Implemented pages link to the existing React routes; unfinished capabilities
// remain navigable but are clearly marked as Coming Soon.
const HR_ROLES = ['superUser', 'employee'];
const REPORT_ITEM = (menu_title, slug, menu_icon, new_item = false, roles = HR_ROLES) => ({
  path: `/app/dashboard/hr-analytics/${slug}`,
  menu_title,
  menu_icon,
  new_item,
  roles,
});

const sidebarMenu = {
  category1: [
    {
      menu_title: 'Dashboards',
      child_routes: [
        REPORT_ITEM('Executive Dashboard', 'executive-dashboard', 'zmdi zmdi-view-dashboard', true),
        REPORT_ITEM('HR Leadership Dashboard', 'hr-leadership-dashboard', 'zmdi zmdi-accounts', true),
        REPORT_ITEM('Division Dashboard', 'division-dashboard', 'zmdi zmdi-chart', true),
        REPORT_ITEM('People Manager Dashboard', 'people-manager-dashboard', 'zmdi zmdi-account-box', true),
        // Preserve existing role-specific dashboard destinations.
        { path: '/app/crm/dashboard', menu_title: 'CEO Dashboard', menu_icon: 'zmdi zmdi-trending-up', roles: ['CEO'] },
        { path: '/app/dashboard/saas', menu_title: 'TM Dashboard', menu_icon: 'zmdi zmdi-accounts-alt', roles: ['Team Manager'] },
      ],
    },
    {
      menu_title: 'Workforce Intelligence',
      child_routes: [
        REPORT_ITEM('Overview', 'overview', 'zmdi zmdi-view-dashboard'),
        REPORT_ITEM('Workforce & Diversity', 'workforce-diversity', 'zmdi zmdi-accounts'),
        REPORT_ITEM('Labour Cost', 'labour-cost', 'zmdi zmdi-money', true),
        REPORT_ITEM('Attrition & Retention', 'attrition-retention', 'zmdi zmdi-trending-down'),
        REPORT_ITEM('Absenteeism', 'absenteeism', 'zmdi zmdi-calendar-check', true),
      ],
    },
    {
      menu_title: 'Roadmap',
      child_routes: [
        REPORT_ITEM('Recruitment', 'recruitment', 'zmdi zmdi-search', true),
        REPORT_ITEM('Performance', 'performance', 'zmdi zmdi-star', true),
        REPORT_ITEM('Scenario Modelling', 'scenario-modelling', 'zmdi zmdi-chart', true),
        // Settings is implemented and must not be marked Coming Soon.
        REPORT_ITEM('Settings', 'settings', 'zmdi zmdi-settings'),
      ],
    },
    {
      menu_title: 'Advanced & Premium',
      child_routes: [
        // The existing Liability Tracker is a functioning application page.
        // { path: '/app/dashboard/liability-dashboard', menu_title: 'Leave Liability', menu_icon: 'zmdi zmdi-assignment', roles: ['superUser'] },
        REPORT_ITEM('Leave Liability', 'leave-liability', 'zmdi zmdi-accounts', true),
        REPORT_ITEM('Succession Planning', 'succession-planning', 'zmdi zmdi-accounts', true),
        REPORT_ITEM('Diversity & Pay Gap', 'diversity-pay-gap', 'zmdi zmdi-balance', true),
        REPORT_ITEM('Engagement', 'engagement', 'zmdi zmdi-mood', true),
        REPORT_ITEM('Sentiment & Polarity', 'sentiment-polarity', 'zmdi zmdi-comment-text', true),
        REPORT_ITEM('Learning & Development', 'learning-development', 'zmdi zmdi-graduation-cap', true),
        REPORT_ITEM('Overtime & Productivity', 'overtime-productivity', 'zmdi zmdi-time', true),
        REPORT_ITEM('Risk & Compliance', 'risk-compliance', 'zmdi zmdi-lock', true),
        REPORT_ITEM('Predictive Analytics', 'predictive-analytics', 'zmdi zmdi-chart', true),
        REPORT_ITEM('Compensation & Benefits', 'compensation-benefits', 'zmdi zmdi-money', true),
        REPORT_ITEM('Integrated Analytics', 'integrated-analytics', 'zmdi zmdi-layers', true),
      ],
    },
    {
      menu_title: 'AI Copilot',
      child_routes: [
        REPORT_ITEM('AI Summary & Insights', 'ai-summary-insights', 'zmdi zmdi-brightness-auto', true),
        REPORT_ITEM('Ask AI', 'ask-ai', 'zmdi zmdi-comment-text', true),
        REPORT_ITEM('AI Report Builder', 'ai-report-builder', 'zmdi zmdi-file-text', true),
        REPORT_ITEM('Action Center', 'action-center', 'zmdi zmdi-check-circle', true),
      ],
    },
    {
      menu_title: 'Data Quality',
      child_routes: [
        REPORT_ITEM('Data Quality', 'data-quality', 'zmdi zmdi-check-circle', true),
      ],
    },
    {
      menu_title: 'Administration',
      child_routes: [
        { path: '/app/dashboard/admin', menu_title: 'Admin Dashboard', menu_icon: 'zmdi zmdi-settings', roles: ['superAdmin'] },
        { path: '/app/dashboard/admin-sample-sheets', menu_title: 'Admin Sample Sheets', menu_icon: 'zmdi zmdi-file-text', roles: ['superAdmin'] },
      ],
    },
  ],
};

export default sidebarMenu;
